export default "__VITE_PUBLIC_ASSET__c715e626__"